(function($) {
	var prev = ($('.testimonials__list').data('prev')) ? $('.testimonials__list').data('prev') : 'Previous';
	var next = ($('.testimonials__list').data('next')) ? $('.testimonials__list').data('next') : 'Next';
	$('.testimonials--carousel .testimonials__list').owlCarousel({
		singleItem: true,
		navigation: true,
		navigationText: ["<span class='sr-only'>"+prev+"</span>", "<span class='sr-only'>"+next+"</span>"],
		pagination: true,
		autoHeight: true,
	});

})( jQuery );